import React, { useState } from "react";
import {
  Container,
  Link,
  Drawer,
  Box,
  IconButton,
  Typography,
  ListItemButton,
  ListItemText,
  List,
  Collapse,
} from "@mui/material";
import Fi from "../common/Field/Fi";
import ListComponent from "../common/ListComponent";
import CloseIcon from "@mui/icons-material/Close";
import Favorite from "../../assets/images/favorite-active.png";
import SearchIcon from "@mui/icons-material/Search";
import Avatar from "../../assets/images/sidebar-avatar.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "../common/Button/Button";

function SideBar({ openDrawer, handleClose }) {
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [openList, setOpenList] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const handleClick = (bool) => {
    setOpenList(bool);
  };
  const [LoginState, setLoginState] = useState(false);
  const currencies = [
    "New Zealand dollar (NZD)",
    "Australian dollar (AED)",
    "Singapore dollar (SD)",
    "Brunei dollar (BRD)",
    "Libyan dinar (LID)",
    "Canadian dollar (CAD)",
    "United States dollar (USD)",
    "Swiss franc (SF)",
    "Euro (EU)",
    "Cayman Islands dollar (CID)",
    "Gibraltar pound (GP)",
    "Pound sterling (PS)",
    "Jordan dinar (JD)",
    "Omani rial (OR)",
    "Bahrain dinar (BD)",
    "Kuwaiti dinar (KD)",
    "New Zealand dollar (NZD)",
    "Singapore dollar (SD)",
    "Brunei dollar (BRD)",
    "Libyan dinar (LID)",
    "Cayman Islands dollar (CID)",
  ];

  const listItemWrapper = (item) => {
    return (
      <ListItemButton sx={{ padding: 0 }}>
        <ListItemText
          primary={
            <Typography variant="body2" sx={{ fontSize: "14px" }}>
              {item}
            </Typography>
          }
        />
      </ListItemButton>
    );
  };

  const populateListComponent = (text) => {
    return (
      <ListComponent
        listItemButtonStyle={{ marginLeft: "-5px" }}
        startIcon={!mobMatch}
        text={text}
      >
        <Fi
          value=""
          transform="translate(7px,7px)"
          label="Search Language"
          endIcon={<SearchIcon sx={{ color: "#616161" }} />}
          sx={{
            width: "286px",
            height: "38.14px",
            marginTop: "26px",
            marginBottom: "16px",
          }}
          height="38.14px"
          size="small"
        />
        <Typography
          variant="caption"
          sx={{ fontSize: "12px", marginTop: "16px", color: "#616161" }}
        >
          Currencies
        </Typography>
        {currencies.map((currency) => {
          return listItemWrapper(currency);
        })}
      </ListComponent>
    );
  };

  const mobileListButtons = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          width: "100%",
          height: "48px",
          backgroundColor: "#EBEBEB",
          marginTop: "26px",
          borderRadius: "8px",
          marginBottom: "26px",
        }}
      >
        <Button
          size="small"
          variant="standard"
          typoVariant="subtitle2"
          typoSize="14px"
          fontWeight="600"
          txColor="text.primary"
          sx={{
            height: "100%",
            backgroundColor: activeButton === "language" ? "#fff" : "",
            borderRadius: "8px",
            width: "50%",
          }}
          onClick={() => {
            setActiveButton("language");
            handleClick();
          }}
        >
          Language
        </Button>
        <Button
          size="small"
          variant="standard"
          typoVariant="subtitle2"
          typoSize="14px"
          fontWeight="600"
          txColor="text.primary"
          sx={{
            height: "100%",
            backgroundColor: activeButton === "currency" ? "#fff" : "",
            borderRadius: "8px",
            width: "50%",
          }}
          onClick={() => {
            setActiveButton("currency");
            handleClick();
          }}
        >
          Currency
        </Button>
      </Box>
    );
  };

  const mobileListComponent = () => {
    return (
      <>
        {mobileListButtons()}
        <Collapse in={openList} timeout="auto" unmountOnExit>
          <Fi
            value=""
            transform="translate(7px,7px)"
            label="Search Language"
            endIcon={<SearchIcon sx={{ color: "#616161" }} />}
            sx={{
              width: "286px",
              height: "38.14px",
              marginBottom: "16px",
            }}
            height="38.14px"
            size="small"
          />
          <Typography
            variant="caption"
            sx={{ fontSize: "12px", marginTop: "16px", color: "#616161" }}
          >
            Currencies
          </Typography>
          <List component="div" disablePadding>
            {currencies.map((currency) => {
              return listItemWrapper(currency);
            })}
          </List>
        </Collapse>
      </>
    );
  };

  return (
    <Drawer
      sx={{
        flexShrink: 0,
        width: "336px !important",
        "& .MuiDrawer-paper": {
          width: "336px",
          padding: "24px",
        },
      }}
      variant="persistent"
      anchor="left"
      open={openDrawer}
    >
      <IconButton
        sx={{ width: "12px", height: "12px" }}
        onClick={() => {
          handleClose();
        }}
      >
        <CloseIcon />
      </IconButton>
      {!mobMatch && (
        <Container
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "34px",
            marginBottom: "25px",
          }}
          disableGutters={true}
        >
          <Box sx={{ display: "flex", columnGap: "24px" }}>
            {LoginState ? (
              <Box sx={{ display: "flex", columnGap: "4px" }}>
                <img src={Avatar} alt="avatar" />
                <Typography
                  variant="subtitle2"
                  fontWeight="600"
                  fontSize="14px"
                >
                  Osama
                </Typography>
              </Box>
            ) : (
              <Link
                onClick={() => {
                  setLoginState(true);
                }}
                sx={{ textDecoration: "none" }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="600"
                  fontSize="14px"
                >
                  Login
                </Typography>
              </Link>
            )}
            <Link
              onClick={() => {
                LoginState && setLoginState(false);
              }}
              sx={{ textDecoration: "none" }}
            >
              <Typography variant="subtitle2" fontWeight="600" fontSize="14px">
                {LoginState ? "Sign out" : "Sign in"}
              </Typography>
            </Link>
          </Box>
          <img src={Favorite} width="24px" height="24px" alt="favorite" />
        </Container>
      )}
      {!mobMatch && populateListComponent("English")}
      {!mobMatch && populateListComponent("AED")}
      {mobMatch && mobileListComponent()}
      {!mobMatch && (
        <Button
          sx={{
            backgroundColor: "#3A474E",
            width: "fit-content",
            height: "40px",
            marginTop: "38px",
          }}
        >
          <Typography
            fontSize="14px"
            fontWeight="600"
            sx={{ textTransform: "none", color: "white" }}
            variant="subtitle2"
          >
            Sell with us
          </Typography>
        </Button>
      )}
    </Drawer>
  );
}

export default SideBar;
